export interface AppActiveSubscriptions {
  id: number
  grootUid: string
  productId?: string
  paymentPlatform?: string
  originalTransactionId?: string
  startDate?: Date
  endDate?: Date
  createdAt?: Date
  updatedAt?: Date
}

export interface PaypalSubscriptions {
  id: number
  grootUid: string
  planCode?: string
  subscriptionId?: string
  startDate?: Date
  endDate?: Date
  insertedAt?: Date
  updatedAt?: Date
  lastSyncedAt?: Date
  syncError?: boolean
}

type CardElementState = {
  empty: boolean
  focus: boolean
  valid: boolean
}

export type CardElementChangeEvent = {
  brand: string
  cvv: CardElementState
  empty: boolean
  expiry: CardElementState
  firstSix: string
  focus: boolean
  lastFour: string
  number: CardElementState
  valid: boolean
}

export interface SubscriptionFormInput {
  first_name: string
  last_name: string
  address1: string
  city: string
  state: string
  country?: string
  postal_code: string
  cardDetails: CardElementChangeEvent
}

export interface SubscriptionInputFieldArgs {
  name: keyof SubscriptionFormInput
  label: string
  isRequired?: boolean
  disabled?: boolean
  type?: string
  errorMessage?: string
}

export enum RecurlyPaymentMethodEnum {
  BRAINTREE_APPLE_PAY = 'braintree_apple_pay',
  CREDIT_CARD = 'credit_card',
  BRAINTREE_V_ZERO = 'braintree_v_zero',
}
export type RecurlyPaymentMethods = `${RecurlyPaymentMethodEnum}`
